export const CONSTANTS = {
  MINUTE: 60000,
};
